// 动态从服务端获取数据
import { getIconByName } from './icons';

export let AVAILABLE_WIDGETS = [];
export let PRESET_GROUP_TYPES = [];
export let presetMenus = [];
export let AVAILABLE_SHORTCUTS = [];
export let aiEngines = [];
export let baseShortcuts = [];
export let initialShortcuts = [];
export let gameShortcuts = [];
export let designShortcuts = [];
export let devShortcuts = [];
export let recommendShortcuts = [];
export let searchEngines = [];
export let guessSearches = [];
export let searchRecommendShortcuts = [];

// New exports for dynamic menus and layouts
export let defaultMenuItems = [];
export let defaultPageData = {};

/**
 * Default fallback channel hardcoded as '0000'
 */
export const DEFAULT_CHANNEL = '0000';

/**
 * Retrieve channel parameter from current page URL or cached in localStorage, fallback to '0000'
 */
export const getChannel = () => {
    try {
        if (typeof window !== 'undefined' && window.location) {
            const params = new URLSearchParams(window.location.search);
            const ch = params.get('channel');
            if (ch && ch.trim()) {
                const cleanChannel = ch.trim();
                try {
                    localStorage.setItem('tab_channel', cleanChannel);
                } catch (e) {
                    // Ignore storage error
                }
                return cleanChannel;
            }

            try {
                const cachedChannel = localStorage.getItem('tab_channel');
                if (cachedChannel && cachedChannel.trim()) {
                    return cachedChannel.trim();
                }
            } catch (e) {
                // Ignore storage error
            }
        }
    } catch (e) {
        console.error("Failed to parse channel from URL:", e);
    }
    return DEFAULT_CHANNEL;
};

/**
 * Sort layout items by sort_order ascending.
 * If sort_order values are identical, widgets take priority over shortcuts.
 */
export const sortLayoutItems = (items = []) => {
    return [...items].sort((a, b) => {
        const orderA = a.sort_order ?? a.sortOrder ?? 0;
        const orderB = b.sort_order ?? b.sortOrder ?? 0;
        if (orderA !== orderB) {
            return orderA - orderB;
        }
        const isWidgetA = a.type === 'widget' ? 1 : 0;
        const isWidgetB = b.type === 'widget' ? 1 : 0;
        return isWidgetB - isWidgetA;
    });
};

export const fetchPresets = async () => {
    try {
        const channel = getChannel();
        const res = await fetch(`/api/v1/preset/sync?channel=${encodeURIComponent(channel)}&t=${Date.now()}`);
        if (!res.ok) {
            console.warn(`Backend returned ${res.status}, using local defaults.`);
            return;
        }
        let json;
        try {
            json = await res.json();
        } catch (e) {
            console.warn("Backend response is not valid JSON, using local defaults.", e);
            return;
        }
        if (json.code === 200 && json.data) {
            AVAILABLE_WIDGETS.length = 0;
            PRESET_GROUP_TYPES.length = 0;
            presetMenus.length = 0;
            AVAILABLE_SHORTCUTS.length = 0;
            defaultMenuItems.length = 0;
            Object.keys(defaultPageData).forEach(k => delete defaultPageData[k]);
            aiEngines.length = 0;
            baseShortcuts.length = 0;
            initialShortcuts.length = 0;
            gameShortcuts.length = 0;
            designShortcuts.length = 0;
            devShortcuts.length = 0;
            recommendShortcuts.length = 0;
            searchRecommendShortcuts.length = 0;

            const data = json.data;
            const widgets = [];
            const categoriesMap = {};
            const allShortcutsMap = {};
            const menusRaw = [];
            const searchEnginesRaw = [];
            const guessSearchesRaw = [];
            const recommendSitesSearch = [];
            const recommendSitesBottom = [];
            guessSearches.length = 0;
            
            console.log("SHORTCUT KEYS", Object.keys(data).filter(k => k.startsWith("SHORTCUT:")));
            for (const key in data) {
                const val = JSON.parse(data[key]);
                // Re-hydrate the icon component
                if (val.icon && typeof val.icon === 'string' && !val.icon.startsWith('http') && !val.icon.startsWith('data:') && !val.icon.startsWith('/')) {
                    val.icon = getIconByName(val.icon);
                }
                
                if (key.startsWith('WIDGET:')) {
                    widgets.push(val);
                } else if (key.startsWith('CATEGORY:') || key.startsWith('SHORTCUT_CATEGORY:') || key.startsWith('WIDGET_CATEGORY:')) {
                    val.shortcuts = [];
                    categoriesMap[val.id] = val;
                } else if (key.startsWith('MENU:')) {
                    menusRaw.push(val);
                } else if (key.startsWith('SEARCH_ENGINE:')) {
                    searchEnginesRaw.push(val);
                } else if (key.startsWith('GUESS_SEARCH:')) {
                    guessSearchesRaw.push(val);
                } else if (key.startsWith('RECOMMEND_SITE:')) {
                    if (val.type === 'search') {
                        recommendSitesSearch.push(val);
                    } else {
                        recommendSitesBottom.push(val);
                    }
                }
            }
            
            
            for (const key in data) {
                const val = JSON.parse(data[key]);
                if (key.startsWith('SHORTCUT:')) {
                    allShortcutsMap[key] = val;
                    if (val.icon && typeof val.icon === 'string' && val.icon.startsWith('http')) {
                        // Keep URL icons as string
                    } else if (val.icon && typeof val.icon === 'string') {
                        val.icon = getIconByName(val.icon);
                    }
                    val.id = key;
                    const catIdStr = val.category_id || key.split(':')[1].split('_')[0]; // fallback
                    if (catIdStr) {
                        const catIds = catIdStr.split(',');
                        catIds.forEach(catId => {
                            if (categoriesMap[catId]) {
                                categoriesMap[catId].shortcuts.push(val);
                            }
                        });
                    }
                }
            }
            
            const widgetsMap = {};
            widgets.forEach(w => widgetsMap[w.id] = w);
            
            // Dynamic sorting and grouping
            const sortedCategories = Object.values(categoriesMap).sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0));
            
            // 1. Map shortcuts to PRESET_GROUP_TYPES
            sortedCategories.filter(c => c.type === 'shortcut' || !c.type).forEach(c => {
                c.shortcuts.sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0));
                PRESET_GROUP_TYPES.push(c);
            });
            
            // 2. Map widgets to AVAILABLE_WIDGETS
            const widgetCategories = sortedCategories.filter(c => c.type === 'widget');
            if (widgetCategories.length > 0) {
                widgetCategories.forEach(c => {
                    const cWidgets = widgets.filter(w => w.category_id === c.id || (!w.category_id && w.id.includes(c.id)))
                                            .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0));
                    AVAILABLE_WIDGETS.push({ category: c.name, items: cWidgets });
                });
            } else {
                // Fallback for missing SQL updates
                AVAILABLE_WIDGETS.push(
                    { category: '实用工具', items: [widgetsMap.w_0, widgetsMap.w_3, widgetsMap.w_4].filter(Boolean) },
                    { category: '影音娱乐', items: [widgetsMap.w_1, widgetsMap.w_2].filter(Boolean) }
                );
            }
            
            // Ensure HotSearch widget is always available
            let utilsCategory = AVAILABLE_WIDGETS.find(c => c.category === '实用工具');
            if (!utilsCategory) {
                utilsCategory = { category: '实用工具', items: [] };
                AVAILABLE_WIDGETS.push(utilsCategory);
            }
            if (!utilsCategory.items.find(w => w.widgetType === 'hotsearch')) {
                utilsCategory.items.push({
                    id: "w_5",
                    type: "widget",
                    widgetType: "hotsearch",
                    name: "热搜榜",
                    icon: getIconByName("TrendingUp"),
                    description: "全网热点话题实时追踪\n掌握最新流行趋势",
                    tag: "热门"
                });
            }
            
            // Generate dynamic menu items and page data
            menusRaw.sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0));
            menusRaw.forEach((m, index) => {
                if (index < 8) {
                    defaultMenuItems.push({
                        id: index,
                        icon: m.icon, // Already hydrated
                        title: m.name
                    });
                }
                presetMenus.push(m);
                
                // Hydrate layout items
                const layoutItems = (m.layout_json || []).map(item => {
                    if (item.type === 'widget') {
                        const wDef = widgetsMap[item.id];
                        return wDef ? { ...wDef, ...item } : item;
                    } else if (item.type === 'shortcut') {
                        // find the shortcut globally
                        const sDef = allShortcutsMap[`SHORTCUT:${item.id}`];
                        return sDef ? { ...sDef, ...item } : item;
                    }
                    return item;
                });
                
                // Sort items by sort_order ascending. If sort_order is equal, widgets take priority
                const sortedLayoutItems = sortLayoutItems(layoutItems);
                m.layout_items = sortedLayoutItems;
                defaultPageData[index] = sortedLayoutItems;
            });

            // Map legacy constants to fetched categories for App.jsx backward compatibility
            devShortcuts.push(...(categoriesMap['dev']?.shortcuts || []));
            designShortcuts.push(...(categoriesMap['design']?.shortcuts || []));
            gameShortcuts.push(...(categoriesMap['leisure']?.shortcuts || []));
            baseShortcuts.push(...(categoriesMap['ecommerce']?.shortcuts || []));
            // Populate recommendations
            if (recommendSitesBottom.length > 0) {
                recommendShortcuts.push(...recommendSitesBottom.sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0)));
            } else {
                recommendShortcuts.push(...(categoriesMap['recommend']?.shortcuts || categoriesMap['rec']?.shortcuts || []));
            }

            if (recommendSitesSearch.length > 0) {
                searchRecommendShortcuts.push(...recommendSitesSearch.sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0)));
            } else {
                searchRecommendShortcuts.push(...(categoriesMap['search_recommend']?.shortcuts || []));
            }
            
            // Populate initial home page with multiple categories
            initialShortcuts.push(...(categoriesMap['ai']?.shortcuts || []));
            initialShortcuts.push(...(categoriesMap['search']?.shortcuts || []));
            initialShortcuts.push(...(categoriesMap['media']?.shortcuts || []));
            initialShortcuts.push(...(categoriesMap['dev']?.shortcuts || []));
            
            aiEngines.push(...(categoriesMap['ai']?.shortcuts || []));
            searchEnginesRaw.sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0));
            searchEngines.push(...searchEnginesRaw);
            
            guessSearchesRaw.sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0));
            guessSearches.push(...guessSearchesRaw.map(g => g.keyword));
            
            AVAILABLE_SHORTCUTS.push(...PRESET_GROUP_TYPES);
            
            console.log("Presets fully loaded from server:", { PRESET_GROUP_TYPES, AVAILABLE_WIDGETS, defaultMenuItems, defaultPageData });
        }
    } catch (err) {
        console.error("Failed to load presets:", err);
    }
};
